import { useParams } from 'react-router-dom'
import { BlogPost as BlogPostSection } from '@/components/sections/blog'
import { SEO } from '@/components/shared/SEO'
import { blogPostBySlug } from '@/content/blogs'

export function BlogPostPage() {
  const { slug } = useParams<{ slug: string }>()
  const post = slug ? blogPostBySlug.get(slug) : undefined

  return (
    <>
      <SEO 
        title={post ? `${post.titleEn} — Will's Thoughts` : 'Post Not Found'}
        description={post?.excerptEn || 'Ideas on AI, vibe coding, and product thinking.'}
        url={`https://vankhoa.dev/blog/${slug}`}
      />
      <main id="main-content" tabIndex={-1}>
        <BlogPostSection />
      </main>
    </>
  )
}
